
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("15Tdz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7e6c70dd55abba00$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $7e6c70dd55abba00$export$2e2bcd8739ae039 = {
    'editor-common-extensibility-extension-lozenge-editToggle.done.editing': "F\xe6rdig med at redigere",
    'editor-common-extensibility-extension-lozenge-editToggle.make.edits': 'Foretag redigeringer',
    'editor-common-extensibility.macro.button.configure': 'Konfigurer {macroName}',
    'fablric.editor.viewAllInserts': "Se alt, der kan inds\xe6ttes",
    'fabric.editor.action': 'Handlingsgenstand',
    'fabric.editor.action.description': 'Opret og tildel handlingsgenstande',
    'fabric.editor.addAltText': 'Alternativ tekst',
    'fabric.editor.addColumnLeft': "Tilf\xf8j kolonne til venstre",
    'fabric.editor.addColumnRight': "Tilf\xf8j kolonne til h\xf8jre",
    'fabric.editor.addCommentOnMedia': "Tilf\xf8j kommentar",
    'fabric.editor.addImageBorder': "Tilf\xf8j kant",
    'fabric.editor.addLoomVideo': 'Optag en Loom-video',
    'fabric.editor.addLoomVideoComment': 'Optag en Loom-videokommentar',
    'fabric.editor.addMediaFiles': "Tilf\xf8j billede, video eller fil",
    'fabric.editor.addRowAbove': "Tilf\xf8j r\xe6kke ovenfor",
    'fabric.editor.addRowBelow': "Tilf\xf8j r\xe6kke nedenfor",
    'fabric.editor.addUpdatedAltText': "Tilf\xf8j alternativ tekst",
    'fabric.editor.ai.ai-panels.actionItemsPageDescription': 'Brug Atlassian Intelligence til at finde handlingspunkter og vise dem i et panel',
    'fabric.editor.ai.ai-panels.actionItemsPageTitle': 'Handlingspunktpanel (Beta)',
    'fabric.editor.ai.ai-panels.summarizePageDescription': 'Brug Atlassian Intelligence til at opsummere denne side og vise den i et panel',
    'fabric.editor.ai.ai-panels.summarizePageTitle': 'Sideoversigtspanel (Beta)',
    'fabric.editor.ai.ai-smart-button.context.reference': 'Valgt indhold',
    'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription': "Genererer indhold, der skal s\xe6ttes ind i opdateringen",
    'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription': 'Opsummerer opdateringens indhold',
    'fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit': "Gener\xe9r",
    'fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel': "Sp\xf8rg Atlassian Intelligence",
    'fabric.editor.ai.config.item.action.edit': 'Rediger',
    'fabric.editor.ai.config.item.action.insert': "Inds\xe6t",
    'fabric.editor.ai.config.item.action.insertAtTop': "Inds\xe6t foroven",
    'fabric.editor.ai.config.item.action.insertBelow': "Inds\xe6t nedenfor",
    'fabric.editor.ai.config.item.action.replace': 'Erstat',
    'fabric.editor.ai.config.item.action.replaceTitle': 'Erstat titel',
    'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip': "Titlen m\xe5 h\xf8jst indeholde {maxLength} tegn",
    'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel': "\xc5bn i chat",
    'fabric.editor.ai.config.item.agent.title': 'Atlassian Intelligence Rovo-medarbejder',
    'fabric.editor.ai.config.item.atlas-shorten-update.description': "Forkorter indholdet for at g\xf8re det mere kortfattet",
    'fabric.editor.ai.config.item.atlas-shorten-update.title': 'Forkort opdateringen',
    'fabric.editor.ai.config.item.bb.pr.description.description': "Opretter en beskrivelse af pullanmodningen med en oversigt over \xe6ndringer",
    'fabric.editor.ai.config.item.bb.pr.description.title': 'Opret beskrivelse af pullanmodning',
    'fabric.editor.ai.config.item.brainstorm.description': "Genererer en liste over id\xe9er til et emne, du angiver",
    'fabric.editor.ai.config.item.brainstorm.promptHint': "Fort\xe6l mig emnet\xa0\u2026",
    'fabric.editor.ai.config.item.brainstorm.promptLabel': 'Brainstorm',
    'fabric.editor.ai.config.item.brainstorm.title': 'Brainstorm',
    'fabric.editor.ai.config.item.changeTone.casualTone.description': "\xc6ndrer tonen i indholdet til afslappet",
    'fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title': 'Afslappet',
    'fabric.editor.ai.config.item.changeTone.casualTone.shortTitle': 'Afslappet',
    'fabric.editor.ai.config.item.changeTone.casualTone.title': 'Skift tone til uformel',
    'fabric.editor.ai.config.item.changeTone.educationalTone.description': "\xc6ndrer tonen i indholdet til p\xe6dagogisk",
    'fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title': "P\xe6dagogisk",
    'fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle': "P\xe6dagogisk",
    'fabric.editor.ai.config.item.changeTone.educationalTone.title': "Skift tone til p\xe6dagogisk",
    'fabric.editor.ai.config.item.changeTone.empatheticTone.description': "\xc6ndrer tonen i indholdet til empatisk",
    'fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title': 'Empatisk',
    'fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle': 'Empatisk',
    'fabric.editor.ai.config.item.changeTone.empatheticTone.title': 'Skift tone til empatisk',
    'fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA': 'Skift tone til ...',
    'fabric.editor.ai.config.item.changeTone.neutralTone.description': "\xc6ndrer tonen i indholdet til neutral",
    'fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title': 'Neutral',
    'fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle': 'Neutral',
    'fabric.editor.ai.config.item.changeTone.neutralTone.title': 'Skift tone til neutral',
    'fabric.editor.ai.config.item.changeTone.professionalTone.description': "\xc6ndrer tonen i indholdet til professionel",
    'fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title': 'Professionel',
    'fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle': 'Professionel',
    'fabric.editor.ai.config.item.changeTone.professionalTone.title': 'Skift tone til professionel',
    'fabric.editor.ai.config.item.convertToBulletList.description': 'Omdanner indholdet til en liste med punktopstilling',
    'fabric.editor.ai.config.item.convertToBulletList.title': 'Omdan til punktopstillet liste',
    'fabric.editor.ai.config.item.convertToTable.description': 'Omformaterer indhold til en tabel med overskrifter',
    'fabric.editor.ai.config.item.convertToTable.title': 'Omdan til tabel',
    'fabric.editor.ai.config.item.draftReply.description': "Udarbejder et udkast til svar baseret p\xe5 sager, der ligner den, du arbejder p\xe5",
    'fabric.editor.ai.config.item.draftReply.title': 'Lav udkast til svar',
    'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description': 'Retter stave- og grammatikfejl',
    'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title': 'Stavning og grammatik',
    'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title': 'Ret stavning og grammatik',
    'fabric.editor.ai.config.item.enhance.improveWriting.description': "Forbedrer klarhed, struktur og tone for at g\xf8re teksten mere interessant og lettere at forst\xe5",
    'fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title': "G\xf8r teksterne bedre",
    'fabric.editor.ai.config.item.enhance.improveWriting.title': "G\xf8r teksterne bedre",
    'fabric.editor.ai.config.item.findActionItems.description': 'Finder handlingselementer i det indhold, du leverer',
    'fabric.editor.ai.config.item.findActionItems.title': 'Find handlingspunkter',
    'fabric.editor.ai.config.item.freeGenerate.disabled.promptHint': "V\xe6lg mellem nedenst\xe5ende (fri generering er deaktiveret i Elevate i \xf8jeblikket)",
    'fabric.editor.ai.config.item.generateContent.promptHint': "Skriv med AI, eller v\xe6lg en af mulighederne herunder",
    'fabric.editor.ai.config.item.improveDescription.default.description': "Omstrukturer sagsbeskrivelsen baseret p\xe5 sagstypen",
    'fabric.editor.ai.config.item.improveDescription.default.title.experiment.one': 'Forbedr beskrivelsen',
    'fabric.editor.ai.config.item.makeLonger.description': "Udvider indholdet baseret p\xe5 den kontekst, du angiver",
    'fabric.editor.ai.config.item.makeLonger.title': "G\xf8r l\xe6ngere",
    'fabric.editor.ai.config.item.range.agent.description': 'Ingen beskrivelse',
    'fabric.editor.ai.config.item.range.agent.prompt.hint': "Bed agenten om at skrive noget, eller v\xe6lg fra listen nedenfor",
    'fabric.editor.ai.config.item.rephrase.description': "Opretter et forslag til omskrivning af dine s\xe6tninger",
    'fabric.editor.ai.config.item.rephrase.title': 'Omformuler',
    'fabric.editor.ai.config.item.shorten.description': "Forkorter indholdet for at g\xf8re det mere kortfattet",
    'fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title': "G\xf8r kortere",
    'fabric.editor.ai.config.item.shorten.title': "G\xf8r kortere",
    'fabric.editor.ai.config.item.suggest.description': "Foresl\xe5r en titel til indhold, du leverer",
    'fabric.editor.ai.config.item.suggest.title': "Foresl\xe5 en titel",
    'fabric.editor.ai.config.item.summarize.description': "Opretter en oversigt over den tekst, du arbejder p\xe5, og fremh\xe6ver n\xf8glepunkter",
    'fabric.editor.ai.config.item.summarize.dropdownItem.title': 'Opsummer markeret tekst',
    'fabric.editor.ai.config.item.summarize.title': 'Opsummer markeret tekst',
    'fabric.editor.ai.config.item.translate.czech': 'Tjekkisk',
    'fabric.editor.ai.config.item.translate.danish': 'Dansk',
    'fabric.editor.ai.config.item.translate.dutch': 'Hollandsk',
    'fabric.editor.ai.config.item.translate.english': 'Engelsk',
    'fabric.editor.ai.config.item.translate.finnish': 'Finsk',
    'fabric.editor.ai.config.item.translate.french': 'Fransk',
    'fabric.editor.ai.config.item.translate.german': 'Tysk',
    'fabric.editor.ai.config.item.translate.hungarian': 'Ungarsk',
    'fabric.editor.ai.config.item.translate.italian': 'Italiensk',
    'fabric.editor.ai.config.item.translate.japanese': 'Japansk',
    'fabric.editor.ai.config.item.translate.nestingParentTitle.ga': "Overs\xe6t",
    'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA': "Overs\xe6t til ...",
    'fabric.editor.ai.config.item.translate.norwegian': 'Norsk',
    'fabric.editor.ai.config.item.translate.russian': 'Russisk',
    'fabric.editor.ai.config.item.translate.spanish': 'Spansk',
    'fabric.editor.ai.config.item.translate.swedish': 'Svensk',
    'fabric.editor.ai.config.item.translateTo.chineseSimplified.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til kinesisk (forenklet)",
    'fabric.editor.ai.config.item.translateTo.chineseSimplified.title': "Overs\xe6t til kinesisk (forenklet)",
    'fabric.editor.ai.config.item.translateTo.chineseTraditional.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til kinesisk (traditionelt)",
    'fabric.editor.ai.config.item.translateTo.chineseTraditional.title': "Overs\xe6t til kinesisk (traditionelt)",
    'fabric.editor.ai.config.item.translateTo.czech.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til tjekkisk",
    'fabric.editor.ai.config.item.translateTo.czech.title': "Overs\xe6t til tjekkisk",
    'fabric.editor.ai.config.item.translateTo.danish.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til dansk",
    'fabric.editor.ai.config.item.translateTo.danish.title': "Overs\xe6t til dansk",
    'fabric.editor.ai.config.item.translateTo.dutch.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til hollandsk",
    'fabric.editor.ai.config.item.translateTo.dutch.title': "Overs\xe6t til hollandsk",
    'fabric.editor.ai.config.item.translateTo.english.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til engelsk",
    'fabric.editor.ai.config.item.translateTo.english.title': "Overs\xe6t til engelsk",
    'fabric.editor.ai.config.item.translateTo.finnish.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til finsk",
    'fabric.editor.ai.config.item.translateTo.finnish.title': "Overs\xe6t til finsk",
    'fabric.editor.ai.config.item.translateTo.french.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til fransk",
    'fabric.editor.ai.config.item.translateTo.french.title': "Overs\xe6t til fransk",
    'fabric.editor.ai.config.item.translateTo.german.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til tysk",
    'fabric.editor.ai.config.item.translateTo.german.title': "Overs\xe6t til tysk",
    'fabric.editor.ai.config.item.translateTo.hungarian.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til ungarsk",
    'fabric.editor.ai.config.item.translateTo.hungarian.title': "Overs\xe6t til ungarsk",
    'fabric.editor.ai.config.item.translateTo.italian.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til italiensk",
    'fabric.editor.ai.config.item.translateTo.italian.title': "Overs\xe6t til italiensk",
    'fabric.editor.ai.config.item.translateTo.japanese.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til japansk",
    'fabric.editor.ai.config.item.translateTo.japanese.title': "Overs\xe6t til japansk",
    'fabric.editor.ai.config.item.translateTo.korean.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til koreansk",
    'fabric.editor.ai.config.item.translateTo.korean.title': "Overs\xe6t til koreansk",
    'fabric.editor.ai.config.item.translateTo.norwegian.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til norsk",
    'fabric.editor.ai.config.item.translateTo.norwegian.title': "Overs\xe6t til norsk",
    'fabric.editor.ai.config.item.translateTo.polish.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til polsk",
    'fabric.editor.ai.config.item.translateTo.polish.title': "Overs\xe6t til polsk",
    'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til portugisisk (brasiliansk)",
    'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title': "Overs\xe6t til portugisisk (brasiliansk)",
    'fabric.editor.ai.config.item.translateTo.russian.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til russisk",
    'fabric.editor.ai.config.item.translateTo.russian.title': "Overs\xe6t til russisk",
    'fabric.editor.ai.config.item.translateTo.spanish.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til spansk",
    'fabric.editor.ai.config.item.translateTo.spanish.title': "Overs\xe6t til spansk",
    'fabric.editor.ai.config.item.translateTo.swedish.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til svensk",
    'fabric.editor.ai.config.item.translateTo.swedish.title': "Overs\xe6t til svensk",
    'fabric.editor.ai.config.item.translateTo.thai.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til thai",
    'fabric.editor.ai.config.item.translateTo.thai.title': "Overs\xe6t til thai",
    'fabric.editor.ai.config.item.translateTo.turkish.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til tyrkisk",
    'fabric.editor.ai.config.item.translateTo.turkish.title': "Overs\xe6t til tyrkisk",
    'fabric.editor.ai.config.item.translateTo.ukrainian.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til ukrainsk",
    'fabric.editor.ai.config.item.translateTo.ukrainian.title': "Overs\xe6t til ukrainsk",
    'fabric.editor.ai.config.item.translateTo.vietnamese.description': "Overs\xe6tter den tekst, du arbejder p\xe5, til vietnamesisk",
    'fabric.editor.ai.config.item.translateTo.vietnamese.title': "Overs\xe6t til vietnamesisk",
    'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle': 'Skift tone',
    'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle': 'Omskriv',
    'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle': "Overs\xe6t",
    'fabric.editor.ai.eventHub.fallbackSuggestedTitle': 'Sidetitel',
    'fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix': 'Side',
    'fabric.editor.ai.experience-application.documentInsertError': "Vi har problemer med at inds\xe6tte svaret. Luk dialogboksen, og pr\xf8v igen.",
    'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage': "Vi har problemer med at danne forh\xe5ndsvisningen. Luk dialogboksen, og pr\xf8v igen.",
    'fabric.editor.ai.experience-application.rateLimitEnforced': "Atlassian Intelligence (AI) har modtaget for mange nylige anmodninger. Pr\xf8v igen om et par minutter, eller l\xe6s om <link>overdreven brug af AI</link>.",
    'fabric.editor.ai.experience-application.tokenLimitExceeded': "Vi kunne ikke f\xe5 et svar. Prompten eller svaret var over gr\xe6nsen for denne anmodning. Luk dialogboksen, og pr\xf8v igen.",
    'fabric.editor.ai.experience-application.unhandledErrorMessage': "Vi har problemer. Luk dialogboksen, og pr\xf8v igen.",
    'fabric.editor.ai.experience.apiError': "Vi kunne ikke f\xe5 svar. Pr\xf8v igen.",
    'fabric.editor.ai.experience.aupViolationMessage': "Din prompt eller dit indhold overholder muligvis ikke vores politik for acceptabel brug. Gennemg\xe5 begge dele, og se vores <link>politik for acceptabel brug</link>, hvis det er n\xf8dvendigt. Hvis problemet forts\xe6tter, kan du overveje at pr\xf8ve en anden prompt eller et andet indhold.",
    'fabric.editor.ai.experience.browseMore.agents': 'Gennemse agenter',
    'fabric.editor.ai.experience.discardMessagePrompt': 'Vil du kassere din prompt?',
    'fabric.editor.ai.experience.discardMessageResponse': 'Vil du kassere dit svar?',
    'fabric.editor.ai.experience.elevateDisabledGenetateError': "Fri generering er deaktiveret i Elevate i \xf8jeblikket.",
    'fabric.editor.ai.experience.engagementBannerLinksText': "\uD83D\uDE80 Nu kan du inds\xe6tte links \uD83D\uDD17 til Jira- og Confluence-indhold i dine prompter.",
    'fabric.editor.ai.experience.footerRightText.agents': 'Drevet af Rovo',
    'fabric.editor.ai.experience.hipaaContentError': "Atlassian Intelligence kunne ikke behandle din anmodning, da dit indhold indeholder links til HIPAA-begr\xe6nset indhold. Fjern disse links, og pr\xf8v igen.",
    'fabric.editor.ai.experience.inputTooShortError': "Indholdet er for kort til at opsummere. Tilf\xf8j mere, og pr\xf8v igen.",
    'fabric.editor.ai.experience.internalServerError': "Atlassian Intelligence (AI) svarer ikke. Pr\xf8v igen senere, eller <link>kontroll\xe9r status for AI</link>.",
    'fabric.editor.ai.experience.labelRight.atlassianIntelligence': 'Atlassian Intelligence',
    'fabric.editor.ai.experience.labelRight.rovo': 'Rovo',
    'fabric.editor.ai.experience.loadingTitle': 'Genererer',
    'fabric.editor.ai.experience.messageTemplateAnalysingQuery': "Analyserer: Gennemg\xe5r dit sp\xf8rgsm\xe5l.",
    'fabric.editor.ai.experience.messageTemplateContentSearch': "S\xf8ger: Et \xf8jeblik, mens vi s\xf8ger efter informationer.",
    'fabric.editor.ai.experience.messageTemplateNextBestTask': "S\xf8ger: Et \xf8jeblik, mens vi s\xf8ger i Jira.",
    'fabric.editor.ai.experience.messageTemplatePageHydration': "S\xf8ger: Et \xf8jeblik, mens vi s\xf8ger p\xe5 siden.",
    'fabric.editor.ai.experience.noResultsSuggestion': 'Ingen resultater',
    'fabric.editor.ai.experience.responseTooSimilarMessage': "Atlassian Intelligence har ingen forslag p\xe5 dette tidspunkt. Pr\xf8v en anden prompt eller andet indhold.",
    'fabric.editor.ai.experience.showMoreButton': 'Vis flere',
    'fabric.editor.ai.experience.suggestionGroupHeading.actions': 'Handlinger',
    'fabric.editor.ai.experience.suggestionGroupHeading.agents': 'Agenter',
    'fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence': 'Atlassian Intelligence',
    'fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource': 'Videnskilde',
    'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents': 'Rovo-medarbejdere',
    'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount': 'Rovo-medarbejdere ({numberOfAgents})',
    'fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount': 'Brug en Rovo-medarbejder ({numberOfAgents})',
    'fabric.editor.ai.experience.useGeneralAiKnowledgeLabel': 'Brug generel viden',
    'fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel': 'Brug viden fra din organisation',
    'fabric.editor.ai.proactive.error.markdownErrorMessage': "Vi har problemer med at danne forh\xe5ndsvisningen. Luk dialogboksen, og pr\xf8v igen.",
    'fabric.editor.ai.proactive.error.unhandledErrorMessage': "Vi har problemer. Luk dialogboksen, og pr\xf8v igen.",
    'fabric.editor.ai.proactive.preview.insertBelowProactiveRecommendation': "Inds\xe6t nedenfor",
    'fabric.editor.ai.proactive.preview.replaceProactiveRecommendation': 'Erstat',
    'fabric.editor.ai.screens.preview.convoAIBeta': 'Anmodninger om indholdsgenerering, der henviser til webadresser, er i beta.',
    'fabric.editor.ai.selectionToolbar.define.disabled.tooltip': "Fremh\xe6v et udtryk, akronym eller en forkortelse",
    'fabric.editor.ai.selectionToolbar.define.title': 'Definer',
    'fabric.editor.ai.toolbar.askAI.title': "Sp\xf8rg AI",
    'fabric.editor.ai.toolbar.improveWriting.title': "G\xf8r teksterne bedre",
    'fabric.editor.ai.toolbar.improveWriting.tooltip': 'Bed Atlassian Intelligence om at forbedre den markerede tekst',
    'fabric.editor.ai.toolbar.simplifiedAI.title': 'AI',
    'fabric.editor.ai.toolbar.titleText': 'Atlassian Intelligence',
    'fabric.editor.ai.toolbar.tryAI.title': "Pr\xf8v AI",
    'fabric.editor.ai.toolbar.tryAI.tooltip': "\xc5bn Atlassian Intelligence",
    'fabric.editor.alignCenter': "Centr\xe9r",
    'fabric.editor.alignImageCenter': "Centr\xe9r",
    'fabric.editor.alignImageLeft': "Venstrejust\xe9r",
    'fabric.editor.alignImageRight': "H\xf8jrejust\xe9r",
    'fabric.editor.alignLeft': "Venstrejust\xe9r",
    'fabric.editor.alignRight': "H\xf8jrejust\xe9r",
    'fabric.editor.alignTableCenter': "Centr\xe9r",
    'fabric.editor.alignTableLeft': "Venstrejust\xe9r",
    'fabric.editor.alignment': 'Tekstjustering',
    'fabric.editor.altText': 'Al tekst',
    'fabric.editor.alttext.validation': 'Fjern alle specialtegn i ALT-tekst.',
    'fabric.editor.annotationToolbar': "V\xe6rkt\xf8jslinje til annotationer",
    'fabric.editor.backLink': "G\xe5 tilbage",
    'fabric.editor.backgroundColor': 'Baggrundsfarve',
    'fabric.editor.blockCardUnavailable': "Det indbyggede link er inden i {node}, og dets visning kan ikke \xe6ndres",
    'fabric.editor.blockControlDelete': 'Slet',
    'fabric.editor.blockControlDragHandleMove': "Tr\xe6k for at flytte",
    'fabric.editor.blockControlDragHandleRearrange': "Tr\xe6k for at omarrangere",
    'fabric.editor.blockControlInsert': "Inds\xe6t",
    'fabric.editor.blockControlMoveDown': 'Flyt ned',
    'fabric.editor.blockControlMoveLeft': 'Flyt til venstre',
    'fabric.editor.blockControlMoveRight': "Flyt til h\xf8jre",
    'fabric.editor.blockControlMoveUp': 'Flyt op',
    'fabric.editor.blockControlMovedDown': 'Indhold er flyttet ned',
    'fabric.editor.blockControlMovedUp': 'Indhold er flyttet op',
    'fabric.editor.blockDescription': 'Vis flere oplysninger om et link, inklusive sammendrag og handlinger',
    'fabric.editor.blockTitle': 'Kort',
    'fabric.editor.blockquote': 'et citat',
    'fabric.editor.blockquote.description': "Inds\xe6t citat",
    'fabric.editor.blockquote2': 'Citer',
    'fabric.editor.bold': 'Fed',
    'fabric.editor.breakoutFullWidthLabel': 'Fuld bredde',
    'fabric.editor.breakoutWideWidthLabel': 'Bredt',
    'fabric.editor.bug': 'Fejl',
    'fabric.editor.canNotSortTable': "\u26A0\uFE0F En tabel med flettede celler kan ikke sorteres",
    'fabric.editor.cancelButton': "Annull\xe9r",
    'fabric.editor.captionPlaceholder': "Tilf\xf8j en billedtekst",
    'fabric.editor.captionPlaceholderWithDoubleClickPrompt': "Tilf\xf8j en billedtekst \u2013 dobbeltklik for forh\xe5ndsvisning",
    'fabric.editor.cardFloatingControls': 'Muligheder for kort',
    'fabric.editor.cellBackground': 'Baggrundsfarve i celle',
    'fabric.editor.cellOptions': 'Egenskaber for celle',
    'fabric.editor.checkUncheckActionItem': "Sl\xe5 handlingselement til/fra",
    'fabric.editor.clearAltTextEdit': 'Ryd alternativ tekst',
    'fabric.editor.clearCells': '{0, plural, one {Ryd celle} other {Ryd celler}}',
    'fabric.editor.clearFormatting': 'Ryd fomattering',
    'fabric.editor.clearLink': 'Ryd link',
    'fabric.editor.clearLinkText': 'Ryd tekst',
    'fabric.editor.closeAltTextEdit': 'Tilbage',
    'fabric.editor.closeFindReplaceDialog': 'Luk',
    'fabric.editor.closeHelpDialog': 'Luk dialogboksen',
    'fabric.editor.code': 'Kode',
    'fabric.editor.code.on': '{textFormattingOff}, kode aktiveret',
    'fabric.editor.codeBidiWarningLabel': "Tegn med tovejsfunktionalitet \xe6ndrer r\xe6kkef\xf8lgen, som teksten er gengivet i. Dette kan udnyttes til at skjule skadelig kode.",
    'fabric.editor.codeBlockCopyButton.copiedToClipboard': 'Kopieret!',
    'fabric.editor.codeBlockCopyButton.copyToClipboard': "Kopi\xe9r som tekst",
    'fabric.editor.codeBlockWrapButton.unwrapCodeBlock': "Sl\xe5 ombrydning fra",
    'fabric.editor.codeBlockWrapButton.wrapCodeBlock': "Sl\xe5 ombrydning til",
    'fabric.editor.codeblock': 'Kodestump',
    'fabric.editor.codeblock.description': "Vis kode med syntaksfremh\xe6vning",
    'fabric.editor.collapseNode': 'skjul indhold',
    'fabric.editor.collapseTable': 'Luk tabel',
    'fabric.editor.colorPicker.menuLabel': "Farvev\xe6lgermenu",
    'fabric.editor.columnDragHandle': 'Kolonneindstillinger',
    'fabric.editor.columnMovedLeft': 'Kolonne flyttet til venstre til {index} af {total}',
    'fabric.editor.columnMovedRight': "Kolonne flyttet til h\xf8jre til {index} af {total}",
    'fabric.editor.columnSelected': 'Kolonne {index} af {total} er valgt',
    'fabric.editor.columns': 'Layout',
    'fabric.editor.columns.advanced.layout.description': "{numberOfColumns, plural, one {Inds\xe6t {numberOfColumns} lige kolonne} other {Inds\xe6t {numberOfColumns} lige kolonner}}",
    'fabric.editor.columns.advanced.layout.single.description': "Inds\xe6t et layout med en enkelt kolonne",
    'fabric.editor.columns.description': 'Opdel din side i afsnit',
    'fabric.editor.columnsAreInserted': '{count, plural, one {En kolonne er blevet indsat} other {{count} kolonner er blevet indsat}}',
    'fabric.editor.columnsAreRemoved': '{count, plural, one {Kolonnen er blevet fjernet} other {{count} kolonner er blevet fjernet}}',
    'fabric.editor.configFailedToLoad': "Kunne ikke indl\xe6ses",
    'fabric.editor.configPanel.cancel': 'Annuller',
    'fabric.editor.configPanel.close': 'Luk',
    'fabric.editor.configPanel.customSelect.createOption': 'Opret',
    'fabric.editor.configPanel.dateRange.custom.from': 'Fra',
    'fabric.editor.configPanel.dateRange.custom.to': 'Til',
    'fabric.editor.configPanel.dateRange.grouping.collapse': 'Skjul',
    'fabric.editor.configPanel.dateRange.grouping.expand': 'Udvid',
    'fabric.editor.configPanel.dateRange.option.custom': 'Brugerdefineret',
    'fabric.editor.configPanel.documentation': 'Dokumentation',
    'fabric.editor.configPanel.errorBoundary.note': "Vi har fortalt teamet det. Du kan stadig redigere og udgive denne side eller tjekke fejlkonsollen for at f\xe5 flere oplysninger.",
    'fabric.editor.configPanel.errorBoundary.title': 'Noget gik galt.',
    'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio': 'Kunne ikke kombinere isMultiple med stilen: alternativknap',
    'fabric.editor.configPanel.formType.addField': "Tilf\xf8j felt",
    'fabric.editor.configPanel.formType.removeField': 'Fjern felt',
    'fabric.editor.configPanel.help': "Har du brug for hj\xe6lp?",
    'fabric.editor.configPanel.invalid': 'Ugyldigt felt',
    'fabric.editor.configPanel.required': "P\xe5kr\xe6vet felt",
    'fabric.editor.configPanel.submit': 'Send',
    'fabric.editor.copiedToClipboard': 'Kopieret!',
    'fabric.editor.copyToClipboard': "Kopi\xe9r",
    'fabric.editor.cornerControl': "Fremh\xe6v tabel",
    'fabric.editor.createComment': 'Kommenter',
    'fabric.editor.createCommentDisabled': 'Du kan kun kommentere tekst, overskrifter, emojier, datoer, omtaler, links og statusser.',
    'fabric.editor.createCommentInvalid': 'Du kan kun kommentere tekst og overskrifter',
    'fabric.editor.createCommentOnInlineNodeSpotlight.action': "Forst\xe5et",
    'fabric.editor.createCommentOnInlineNodeSpotlight.body': 'Nu kan du oprette kommentarer til indlejrede elementer som links, datoer, statusser og omtaler.',
    'fabric.editor.customPanel': 'Brugerdefineret panel',
    'fabric.editor.customPanel.description': "Tilf\xf8j en note med en emoji og farvet baggrund",
    'fabric.editor.datasource.assetsObjects.description': "Inds\xe6t objekter fra Aktiver i Jira Service Management med s\xf8gning og filtrering",
    'fabric.editor.datasource.assetsObjectsGeneralAvailability': 'Aktiver',
    'fabric.editor.datasource.confluenceSearch': "Inds\xe6t Confluence-liste",
    'fabric.editor.datasource.confluenceSearch.description': "Inds\xe6t liste over s\xf8geresultater fra Confluence med forbedret s\xf8gning, filtrering og konfiguration.",
    'fabric.editor.datasource.jiraIssue': 'Jira-sager',
    'fabric.editor.datasource.jiraIssue.description': "Inds\xe6t Jira-sager fra Jira Cloud med forbedret s\xf8gning, filtrering og konfiguration.",
    'fabric.editor.datasource.jiraIssue.description.issue-term-refresh': "Inds\xe6t Jira-sager fra Jira Cloud med forbedret s\xf8gning, filtrering og konfiguration.",
    'fabric.editor.datasource.jiraIssue.issue-term-refresh': 'Jira-sager',
    'fabric.editor.datasourceAppearanceTitle': 'Liste',
    'fabric.editor.datasourceTitle': "Rediger s\xf8gning",
    'fabric.editor.date': 'Dato',
    'fabric.editor.date.description': "Tilf\xf8j en dato med en kalender",
    'fabric.editor.datePickerOpenedAlert': "Pop\xa0op-vinduet til datoredigering er \xe5bnet. Tryk p\xe5 Tabulatorknappen for at f\xe5 adgang til pop\xa0op-vinduet",
    'fabric.editor.decision': 'Beslutning',
    'fabric.editor.decision.description': "Registr\xe9r beslutninger, s\xe5 de er lette at finde igen",
    'fabric.editor.decisionPlaceholder': "Tilf\xf8j en beslutning ...",
    'fabric.editor.decreaseSize': "Reducer tabel- eller mediest\xf8rrelse",
    'fabric.editor.defaultAltText': 'Dokument',
    'fabric.editor.delete': 'Slet',
    'fabric.editor.description': 'Beskrivelse',
    'fabric.editor.displayBlock': 'Vis som kort',
    'fabric.editor.displayEmbed': 'Vis som indlejret',
    'fabric.editor.displayInline': 'Vis indbygget',
    'fabric.editor.displayLink': 'Vis som tekst',
    'fabric.editor.displayOptionUnavailableInParentNode': "Denne visningsmulighed er ikke tilg\xe6ngelig i {node}",
    'fabric.editor.displayText': 'Vist tekst',
    'fabric.editor.distributeColumns': 'Fordel kolonner',
    'fabric.editor.dropPlaceholderLabel': 'Dokument',
    'fabric.editor.ecombedDescription': "Vis en interaktiv forh\xe5ndsvisning af et link",
    'fabric.editor.edit': "Redig\xe9r",
    'fabric.editor.edit.datasource': "Rediger s\xf8gning",
    'fabric.editor.edit.searchInput': "Tilf\xf8j et link",
    'fabric.editor.editAccessTitle': 'Du skal have redigeringsadgang',
    'fabric.editor.editAltText': 'Rediger alternativ tekst',
    'fabric.editor.editDatasourceStandalone': 'Rediger',
    'fabric.editor.editDatasourceStandaloneTooltip': "Rediger s\xf8gning",
    'fabric.editor.editDateText': 'Rediger dato',
    'fabric.editor.editDropdownEditDatasourceTitle': "Rediger s\xf8gning",
    'fabric.editor.editDropdownEditLinkTitle': 'Rediger link',
    'fabric.editor.editDropdownExpandIconLabel': 'Udvid rullemenu',
    'fabric.editor.editDropdownTriggerTitle': 'Rediger',
    'fabric.editor.editLink': "Redig\xe9r link",
    'fabric.editor.editMode.inviteToEditButton.title': "Invit\xe9r til at redigere",
    'fabric.editor.editStatusColor': 'Rediger statusfarve',
    'fabric.editor.editStatusText': 'Rediger status',
    'fabric.editor.editableContentLabel': 'Redigerbart indhold',
    'fabric.editor.editorHelp': "Hj\xe6lp til redigering",
    'fabric.editor.editors': "Redakt\xf8rer",
    'fabric.editor.elementBrowser.help': "Hj\xe6lp",
    'fabric.editor.elementInsertSidePanel.title': "Inds\xe6t",
    'fabric.editor.elementbrowser.categorylist.category-admin': 'Administration',
    'fabric.editor.elementbrowser.categorylist.category-ai': 'Atlassian Intelligence',
    'fabric.editor.elementbrowser.categorylist.category-all': 'Alle',
    'fabric.editor.elementbrowser.categorylist.category-communication': 'Kommunikation',
    'fabric.editor.elementbrowser.categorylist.category-confluence-content': 'Confluence-indhold',
    'fabric.editor.elementbrowser.categorylist.category-development': 'Udvikling',
    'fabric.editor.elementbrowser.categorylist.category-external-content': 'Eksternt indhold',
    'fabric.editor.elementbrowser.categorylist.category-formatting': 'Formatering',
    'fabric.editor.elementbrowser.categorylist.category-media': 'Medie',
    'fabric.editor.elementbrowser.categorylist.category-navigation': 'Navigation',
    'fabric.editor.elementbrowser.categorylist.category-reporting': 'Rapportering',
    'fabric.editor.elementbrowser.categorylist.category-visuals': 'Grafik og billeder',
    'fabric.editor.elementbrowser.search.empty-state.heading': "Ingen resultater matcher din s\xf8gning",
    'fabric.editor.elementbrowser.search.empty-state.sub-heading': "Pr\xf8v et andet s\xf8geord, eller find nye apps til Atlassian-produkter.",
    'fabric.editor.elementbrowser.search.empty-state.sub-heading.link': "G\xe5 p\xe5 opdagelse p\xe5 Atlassian Marketplace",
    'fabric.editor.elementbrowser.searchbar.assistive.text.default': "{count, plural, =0 {Der er ikke noget, der matcher din s\xf8gning.} one {{count} forslag er tilg\xe6ngeligt som standard.} other {{count} forslag er tilg\xe6ngelige som standard.}}",
    'fabric.editor.elementbrowser.searchbar.assistive.text.result': "{count, plural, =0 {Der er ikke noget, der matcher din s\xf8gning.} one {{count} muligt forslag til indtastet tekst.} other {{count} mulige forslag til indtastet tekst.}}",
    'fabric.editor.elementbrowser.searchbar.elementAfterInput': 'Indtast',
    'fabric.editor.elementbrowser.searchbar.placeholder': "S\xf8g",
    'fabric.editor.elementbrowser.sidebar.heading': 'Gennemse',
    'fabric.editor.embedTitle': 'Indlejr',
    'fabric.editor.emoji': 'Emoji',
    'fabric.editor.emoji.description': "Brug hum\xf8rikoner for at udtrykke id\xe9er \uD83C\uDF89 og f\xf8lelser \uD83D\uDE04",
    'fabric.editor.emptyLink': 'Indtast et link.',
    'fabric.editor.emptySearchResults': 'Vi kunne ikke finde nogen resultater.',
    'fabric.editor.emptySearchResultsSuggestion': "V\xe6lg {buttonName} for at gennemse inds\xe6ttelser.",
    'fabric.editor.epic': 'Epic',
    'fabric.editor.error': 'Fejl',
    'fabric.editor.errorPanel': 'Fejlpanel',
    'fabric.editor.errorPanel.description': 'Vis fejl i et farvel panel',
    'fabric.editor.expand': 'Udvid',
    'fabric.editor.expand.description': "Inds\xe6t en udvidelse",
    'fabric.editor.expandAriaLabel': 'Giv denne udvidelse en titel',
    'fabric.editor.expandDefaultTitle': 'Klik her for at udvide...',
    'fabric.editor.expandNode': 'Udvid indhold',
    'fabric.editor.expandPlaceholder': 'Giv denne udvidelse en titel...',
    'fabric.editor.extension.confirmDeleteLinkedModalMessage': 'Hvis du sletter {nodeName}, brydes forbindelsen til alt, der er forbundet til den.',
    'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix': 'Sletter',
    'fabric.editor.extension.confirmDeleteLinkedModalOKButton': 'Slet',
    'fabric.editor.extension.deleteElementTitle': 'Slet element',
    'fabric.editor.extension.sourceNoTitledName': 'dette element',
    'fabric.editor.extensions.config-panel.save-indicator': "Alle \xe6ndringer gemmes altid automatisk",
    'fabric.editor.externalExtensionsHeading': 'Apps',
    'fabric.editor.externalMediaFile': 'Ekstern mediefil',
    'fabric.editor.failed_to_upload': 'Upload mislykkedes',
    'fabric.editor.feedbackDialog': 'Giv feedback',
    'fabric.editor.feedbackDialog.description': "Fort\xe6l os om din oplevelse med den nye editor.",
    'fabric.editor.find': 'Find',
    'fabric.editor.findNext': "Find n\xe6ste",
    'fabric.editor.findPrevious': 'Find forrige',
    'fabric.editor.findReplaceToolbarButton': 'Find og erstat',
    'fabric.editor.fiveColumns': 'Layout med fem kolonner',
    'fabric.editor.floatingToolbar.confirmModalCancel': 'Annuller',
    'fabric.editor.floatingToolbar.confirmModalCheckboxLabel': "Slet ogs\xe5 forbundne elementer",
    'fabric.editor.floatingToolbar.confirmModalConnectedUnit': '{amount, plural, =0 {{name}} one {{name} (+1 forbundet element)} other {{name} (+{amount,number} forbundne elementer)}}',
    'fabric.editor.floatingToolbar.confirmModalHeading': 'Er du sikker?',
    'fabric.editor.floatingToolbar.confirmModalOK': 'OK',
    'fabric.editor.floatingToolbar.floatingToolbarAnnouncer': "Flydende v\xe6rkt\xf8jslinje er blevet \xe5bnet",
    'fabric.editor.floatingToolbar.floatingToolbarAriaLabel': "Flydende v\xe6rkt\xf8jslinje",
    'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel': 'Layoutindstillinger',
    'fabric.editor.floatingToolbar.scrollLeft': 'Rul til venstre',
    'fabric.editor.floatingToolbar.scrollRight': "Rul til h\xf8jre",
    'fabric.editor.focusTableResizeHandle': "H\xe5ndtag til \xe6ndring af st\xf8rrelse p\xe5 tabel i fokus",
    'fabric.editor.fourColumns': 'Layout med fire kolonner',
    'fabric.editor.headerColumn': 'Overskriftskolonne',
    'fabric.editor.headerRow': "Overskriftsr\xe6kke",
    'fabric.editor.heading1': 'Overskrift 1',
    'fabric.editor.heading1Description': "Brug denne til overskrift p\xe5 \xf8verste niveau",
    'fabric.editor.heading2': 'Overskrift 2',
    'fabric.editor.heading2Description': 'Brug denne til hovedafsnit',
    'fabric.editor.heading3': 'Overskrift 3',
    'fabric.editor.heading3Description': 'Brug denne til underafsnit og mindre overskrifter',
    'fabric.editor.heading4': 'Overskrift 4',
    'fabric.editor.heading4Description': 'Brug denne til dybe overskrifter',
    'fabric.editor.heading5': 'Overskrift 5',
    'fabric.editor.heading5Description': 'Brug denne til at gruppere listeelementer',
    'fabric.editor.heading6': 'Overskrift 6',
    'fabric.editor.heading6Description': "Brug denne til overskrift p\xe5 lavt niveau",
    'fabric.editor.headingLink.ascOrderLabel': "Sort\xe9r kolonnen fra \xc5 til A",
    'fabric.editor.headingLink.descOrderLabel': 'Ryd sortering',
    'fabric.editor.headingLink.hyperlinkIconBlogLabel': 'Blog',
    'fabric.editor.headingLink.hyperlinkIconBugLabel': 'Fejl',
    'fabric.editor.headingLink.hyperlinkIconIssueLabel': 'Sag',
    'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh': 'Sag',
    'fabric.editor.headingLink.hyperlinkIconPageLabel': 'Side',
    'fabric.editor.headingLink.hyperlinkIconStoryLabel': 'Historie',
    'fabric.editor.headingLink.hyperlinkIconTaskLabel': 'Opgave',
    'fabric.editor.headingLink.invalidLabel': "\u26A0\uFE0F En tabel med flettede celler kan ikke sorteres",
    'fabric.editor.headingLink.noOrderLabel': "Sort\xe9r kolonnen fra A til \xc5",
    'fabric.editor.help': "Hj\xe6lp",
    'fabric.editor.help.description': 'Se alle tastaturgenveje og Markdown-muligheder',
    'fabric.editor.helpDialogTips': "Tryk p\xe5 {keyMap} for at f\xe5 hurtig adgang til denne dialogboks",
    'fabric.editor.highlight': "Farve p\xe5 fremh\xe6vning",
    'fabric.editor.highlightColor': "Sl\xe5 fremh\xe6vningsfarvepalet til/fra",
    'fabric.editor.highlightFloatingToolbar': "Fremh\xe6v",
    'fabric.editor.horizontalRule': 'Rumdeler',
    'fabric.editor.horizontalRule.description': 'Adskil indhold med en vandret linje',
    'fabric.editor.hyperlink.linkVisibleLabel': "Inds\xe6t eller s\xf8g efter link",
    'fabric.editor.hyperlink.searchLinkAriaDescription': "Der vises forslag nedenfor, n\xe5r du skriver i feltet",
    'fabric.editor.hyperlink.searchLinkResults': '{count, plural, =0 {ingen resultater fundet} one {Der blev fundet {count,number} resultat} other {Der blev fundet {count,number} resultater}}',
    'fabric.editor.hyperlink.textVisibleLabel': 'Visningstekst (valgfrit)',
    'fabric.editor.hyperlinkToolbarPlaceholder': "Inds\xe6t eller s\xf8g efter link",
    'fabric.editor.image': 'Billeder',
    'fabric.editor.image.fullWidthLabel': 'Fuld bredde',
    'fabric.editor.imageBorderBold': 'Fed',
    'fabric.editor.imageBorderColor': 'Farve',
    'fabric.editor.imageBorderColor.dropdownAriaLabel': 'Indstillinger for billedkant Rullemenuen farver',
    'fabric.editor.imageBorderMedium': 'Medium',
    'fabric.editor.imageBorderOptions': 'Kantmuligheder',
    'fabric.editor.imageBorderSize': "St\xf8rrelse",
    'fabric.editor.imageBorderSize.dropdownAriaLabel': "Indstillinger for billedkant Rullemenuen st\xf8rrelse",
    'fabric.editor.imageBorderSubtle': 'Diskret',
    'fabric.editor.improvement': 'Forbedring',
    'fabric.editor.increaseSize': "For\xf8g tabel- eller mediest\xf8rrelse",
    'fabric.editor.indent': 'Ryk ind',
    'fabric.editor.info': 'Info',
    'fabric.editor.infoPanel': 'Informationspanel',
    'fabric.editor.infoPanel.description': "Fremh\xe6v information i et farvet panel",
    'fabric.editor.inlineConfigureLink': 'Konfigurer link',
    'fabric.editor.inlineDescription': 'Vis link som indbygget tekst',
    'fabric.editor.inlineGoToLink': "G\xe5 til link",
    'fabric.editor.inlineOverlay': 'Konfigurer',
    'fabric.editor.inlineTitle': 'Indbyg',
    'fabric.editor.inputQueryAssistiveTxt': "N\xe5r resultater med automatisk udfyldning er tilg\xe6ngelige, skal du bruge pil op og pil ned til at gennemse og Enter til at v\xe6lge. Brugere af touchenheder kan trykke eller stryge.",
    'fabric.editor.insertColumn': "Inds\xe6t kolonne til h\xf8jre",
    'fabric.editor.insertColumnDrag': "Inds\xe6t kolonne",
    'fabric.editor.insertMenu': "Inds\xe6t elementer",
    'fabric.editor.insertRightRail.close': 'Luk',
    'fabric.editor.insertRightRail.title': "Inds\xe6t",
    'fabric.editor.insertRow': "Inds\xe6t r\xe6kke under",
    'fabric.editor.insertRowDrag': "Inds\xe6t r\xe6kke",
    'fabric.editor.insertTableColumn': "Inds\xe6t tabelkolonne",
    'fabric.editor.insertTableRow': "Inds\xe6t tabelr\xe6kke",
    'fabric.editor.invalidDateError': 'Indtast en gyldig dato',
    'fabric.editor.invalidLink': 'Indtast et gyldigt link.',
    'fabric.editor.inviteItem.title': "{userRole, select, admin {Inviter teammedlemmer til {productName}} trusted {Inviter teammedlemmer til {productName}} other {Tilf\xf8j teammedlem til {productName}}}",
    'fabric.editor.italic': 'Kursiv',
    'fabric.editor.keyboardShortcuts': 'Tastaturgenveje',
    'fabric.editor.layout.columnOption': '{count, plural, one {Kolonne} other {{count} kolonner}}',
    'fabric.editor.layout.controls.placeholder': "/ for at inds\xe6tte",
    'fabric.editor.layout.placeholder': "Tilf\xf8j indhold",
    'fabric.editor.layout.resizeLayout': "\xc6ndr st\xf8rrelse p\xe5 layout",
    'fabric.editor.layoutFixedWidth': 'Tilbage til centrering',
    'fabric.editor.layoutFullWidth': 'Vis i fuld bredde',
    'fabric.editor.layoutStateFixedWidth': 'Centreret',
    'fabric.editor.layoutStateFullWidth': 'Fuld bredde',
    'fabric.editor.layoutStateWide': 'Bredt',
    'fabric.editor.layoutWide': 'Vis bred',
    'fabric.editor.leftSidebar': "Layout med venstre sidebj\xe6lke",
    'fabric.editor.link': 'Link',
    'fabric.editor.link.description': "Inds\xe6t et link",
    'fabric.editor.linkAddress': 'Linkadresse',
    'fabric.editor.linkPlaceholder': "Inds\xe6t link",
    'fabric.editor.lists': 'Liste',
    'fabric.editor.listsFormat': 'Listeformatering',
    'fabric.editor.lockColumns': "Faste s\xf8jlebredder",
    'fabric.editor.longEmptyNodePlaceholderText': "Skriv / for at inds\xe6tte elementer",
    'fabric.editor.markdown': 'Markdown',
    'fabric.editor.matchCase': "Match store/sm\xe5 bogstaver",
    'fabric.editor.media.DefaultMediaWidthDecreased': '{newMediaWidth, plural, one {Mediebredde reduceret til {newMediaWidth,number} pixel.} other {Mediebredde reduceret til {newMediaWidth,number} pixels.}}',
    'fabric.editor.media.DefaultMediaWidthIncreased': "{newMediaWidth, plural, one {Mediebredde \xf8get til {newMediaWidth,number} pixel.} other {Mediebredde \xf8get til {newMediaWidth,number} pixels.}}",
    'fabric.editor.media.MediaWidthIsMin': "Medier reduceret til minimumsst\xf8rrelsen",
    'fabric.editor.media.insert.cancel': 'Annuller',
    'fabric.editor.media.insert.fileTabTitle': 'Fil',
    'fabric.editor.media.insert.fromUrlErrorMessage': "Vi kan desv\xe6rre ikke tilf\xf8je dette billedlink. Download billedet, og tr\xe6k og slip det til siden.",
    'fabric.editor.media.insert.fromUrlWarning': "Billedet er muligvis ikke synligt for andre p\xe5 grund af kildebegr\xe6nsninger. Du kan pr\xf8ve at uploade filen i stedet.",
    'fabric.editor.media.insert.insert': "Inds\xe6t",
    'fabric.editor.media.insert.invalidUrlErrorMessage': 'Ugyldigt link',
    'fabric.editor.media.insert.linkTabTitle': 'Link',
    'fabric.editor.media.insert.loadPreview': "Indl\xe6s forh\xe5ndsvisning",
    'fabric.editor.media.insert.localFileErrorMessage': "Filen kunne ikke overf\xf8res.",
    'fabric.editor.media.insert.localFileNetworkErrorMessage': "Fejl ved overf\xf8rsel af fil. Kontroll\xe9r filstien eller netv\xe6rket.",
    'fabric.editor.media.insert.mediaAlt': "Forh\xe5ndsvisning af uploadet billede eller videofil",
    'fabric.editor.media.insert.mediaPickerPopupAriaLabel': "Mediev\xe6lger",
    'fabric.editor.media.insert.pasteLinkToUpload': "Kopi\xe9r og inds\xe6t link for at uploade",
    'fabric.editor.media.insert.upload': 'Upload',
    'fabric.editor.media.pixelEntry.MediaWidthIsMax': "Medier \xf8get til maksimumsst\xf8rrelsen",
    'fabric.editor.media.pixelEntry.ResizeOption': "Tilpas st\xf8rrelsen",
    'fabric.editor.media.pixelEntry.closePixelEntry': 'Luk',
    'fabric.editor.media.pixelEntry.inputHeightAriaLabel': "h\xf8jdeinput",
    'fabric.editor.media.pixelEntry.inputHeightTooltip': "H\xf8jde",
    'fabric.editor.media.pixelEntry.inputWidthAriaLabel': 'Maks. bredde {maxWidth} px',
    'fabric.editor.media.pixelEntry.inputWidthLabel': 'Bredde',
    'fabric.editor.media.pixelEntry.inputWidthTooltip': 'Maks. bredde {maxWidth} pixels',
    'fabric.editor.media.pixelEntry.migrationButtonText': 'Konverter til pixels',
    'fabric.editor.media.pixelEntry.migrationButtonTooltip': "Overf\xf8r fra procentdel til fast pixelst\xf8rrelse",
    'fabric.editor.media.pixelEntry.submitButtonText': 'Indsend',
    'fabric.editor.media.pixelEntry.validationFailedMessage': 'Validering af bredde mislykkedes',
    'fabric.editor.mediaAddLink': "Tilf\xf8j link",
    'fabric.editor.mediaFiles': 'Billede, video eller fil',
    'fabric.editor.mediaFiles.description': "Tilf\xf8j billeder eller andre filer til din side",
    'fabric.editor.mediaGroupDeleteLabel': 'Slet',
    'fabric.editor.media_change_mediainline_caption_warn': 'Indbygget (billedtekst fjernes)',
    'fabric.editor.media_change_mediainline_default': 'Indbyg',
    'fabric.editor.media_change_mediasingle': "Original st\xf8rrelse",
    'fabric.editor.mention': "Ben\xe6vnelse",
    'fabric.editor.mention.description': 'Omtal nogen for at sende dem en notifikation',
    'fabric.editor.mentionNode.label': 'Tagget bruger',
    'fabric.editor.mentionsAddLabel': "ikon for tilf\xf8j",
    'fabric.editor.mentionsIconLabel': 'Omtal',
    'fabric.editor.mergeCells': 'Flet celler',
    'fabric.editor.moreFormatting': 'Mere formatering',
    'fabric.editor.moveColumnLeft': '{0, plural, one {Flyt kolonne til venstre} other {Flyt kolonner til venstre}}',
    'fabric.editor.moveColumnRight': "{0, plural, one {Flyt kolonne til h\xf8jre} other {Flyt kolonner til h\xf8jre}}",
    'fabric.editor.moveDownDown': "{0, plural, one {Flyt r\xe6kke ned} other {Flyt r\xe6kker ned}}",
    'fabric.editor.moveRowUp': "{0, plural, one {Flyt r\xe6kke op} other {Flyt r\xe6kker op}}",
    'fabric.editor.navigate.toolbar.editor': "Naviger til v\xe6rkt\xf8jslinje til redigeringsprogram",
    'fabric.editor.navigate.toolbar.floating': "Naviger til flydende v\xe6rkt\xf8jslinje",
    'fabric.editor.noResultsFound': 'Ingen resultater',
    'fabric.editor.noSearchResults': "Ingen s\xf8geresultater",
    'fabric.editor.normal': 'Normal tekst',
    'fabric.editor.note': 'Note',
    'fabric.editor.notePanel': "Bem\xe6rkningspanel",
    'fabric.editor.notePanel.description': "Tilf\xf8j en note i et farvet panel",
    'fabric.editor.numberedColumn': 'Kolonne med nummerering',
    'fabric.editor.off': '{formattingType} fra',
    'fabric.editor.offlineErrorFallbackDescription': "Pr\xf8v at genindl\xe6se siden.",
    'fabric.editor.offlineErrorFallbackHeading': 'Noget gik galt!',
    'fabric.editor.on': '{formattingType} til',
    'fabric.editor.openCellOptions': "\xc5bn celleegenskaber",
    'fabric.editor.openLink': "\xc5bn link i en nye fane",
    'fabric.editor.orderedList': 'Nummereret liste',
    'fabric.editor.orderedList.description': 'Opret en sorteret liste',
    'fabric.editor.other': "Andet \u2026",
    'fabric.editor.outdent': 'Ryk ud',
    'fabric.editor.overflowMenuViewMore': 'Vis mere',
    'fabric.editor.pageActionsLabel': 'Sidehandlinger',
    'fabric.editor.panel': 'Panel',
    'fabric.editor.panel.backgroundColor': 'Baggrundsfarve',
    'fabric.editor.panel.custom': 'Brugerdefineret',
    'fabric.editor.panel.emoji': "Tilf\xf8j emoji",
    'fabric.editor.panel.panelsGroup': 'Paneltyper',
    'fabric.editor.pasteOptions': "Indstillinger for inds\xe6t",
    'fabric.editor.pastePlainText': "Inds\xe6t almindelig tekst",
    'fabric.editor.placeholderAltText': 'Beskriv billedet med alternativ tekst',
    'fabric.editor.placeholderText': 'Midlertidig text',
    'fabric.editor.placeholderText.description': "Inds\xe6t en pladsholdertekst p\xe5 siden",
    'fabric.editor.placeholderTextPlaceholder': "Tilf\xf8j midlertidig tekst",
    'fabric.editor.plainText': 'Brug almindelig tekst',
    'fabric.editor.preferencesLink': 'Indstillinger for links',
    'fabric.editor.quickInsert': "Hurtig inds\xe6tning",
    'fabric.editor.recordLoomShortTitle': 'Optag',
    'fabric.editor.recordVideo': 'Optag en Loom-video',
    'fabric.editor.recordVideo.description': "Optag og del din sk\xe6rm og dine tanker",
    'fabric.editor.redo': 'Gentag',
    'fabric.editor.remove': 'Fjern',
    'fabric.editor.removeColumns': '{0, plural, one {Slet kolonne} other {Slet kolonner}}',
    'fabric.editor.removeEmoji': 'Fjern emoji',
    'fabric.editor.removeImageBorder': 'Fjern kant',
    'fabric.editor.removeRows': "{0, plural, one {Slet r\xe6kke} other {Slet r\xe6kker}}",
    'fabric.editor.replace': 'Erstat',
    'fabric.editor.replaceAll': 'Erstat alle',
    'fabric.editor.replaceSuccess': '{numberOfMatches, plural, one {{numberOfMatches,number} match erstattet} other {{numberOfMatches,number} match erstattet}}',
    'fabric.editor.replaceWith': 'Erstat med',
    'fabric.editor.requestToEdit': 'Anmod om at redigere',
    'fabric.editor.requestToEditDescription': "N\xe5r du anmoder om adgang, modtager sideejeren en notifikation.",
    'fabric.editor.requestToEditDismiss': 'Luk',
    'fabric.editor.resultsCount': '{selectedMatchPosition} af {totalResultsCount}',
    'fabric.editor.richText': 'Brug RTF',
    'fabric.editor.rightSidebar': "Layout med h\xf8jre sidebj\xe6lke",
    'fabric.editor.rowControl': "Fremh\xe6v r\xe6kke",
    'fabric.editor.rowDragHandle': "R\xe6kkeindstillinger",
    'fabric.editor.rowMovedDown': "R\xe6kke flyttet ned til {index} af {total}",
    'fabric.editor.rowMovedUp': "R\xe6kke flyttet op til {index} af {total}",
    'fabric.editor.rowSelected': "R\xe6kke {index} af {total} er valgt",
    'fabric.editor.rowsAreInserted': "{count, plural, one {En r\xe6kke er blevet indsat} other {{count} r\xe6kker er blevet indsat}}",
    'fabric.editor.rowsAreRemoved': "{count, plural, one {R\xe6kken er blevet fjernet} other {{count} r\xe6kker er blevet fjernet}}",
    'fabric.editor.saveButton': 'Gem',
    'fabric.editor.searchResults': "{itemsLength, plural, one {{itemsLength,number} s\xf8geresultat tilg\xe6ngeligt. Brug piletasterne op og ned til at navigere gennem mulighederne. Tryk p\xe5 Enter for at v\xe6lge en mulighed.} other {{itemsLength,number} s\xf8geresultater er tilg\xe6ngelige. Brug piletasterne op og ned til at navigere gennem mulighederne. Tryk p\xe5 Enter for at v\xe6lge en mulighed.}}",
    'fabric.editor.selectColumnResize': "V\xe6lg \xe6ndring af kolonnest\xf8rrelse",
    'fabric.editor.selectLanguage': "V\xe6lg sprog",
    'fabric.editor.selectTableColumn': "V\xe6lg tabelkolonne",
    'fabric.editor.selectTableRow': "V\xe6lg tabelr\xe6kke",
    'fabric.editor.selectionExtensionDropdownButtonLabel': "V\xe6lg app",
    'fabric.editor.settingsLinks': "G\xe5 til Indstillinger for links",
    'fabric.editor.shortEmptyNodePlaceholderText': "/ for at inds\xe6tte",
    'fabric.editor.shortcut': 'Genvej til tekst',
    'fabric.editor.single': "Layout med \xe9n kolonne",
    'fabric.editor.singleColumns': 'Layout med en kolonne',
    'fabric.editor.sortColumnASC': "Sorter kolonnen fra A \u2192 \xc5",
    'fabric.editor.sortColumnDESC': "Sorter kolonnen fra \xc5 \u2192 A",
    'fabric.editor.sortColumnDecreasing': "Sort\xe9r faldende",
    'fabric.editor.sortColumnIncreasing': "Sort\xe9r stigende",
    'fabric.editor.splitCell': 'Opdel celle',
    'fabric.editor.status': 'Status',
    'fabric.editor.status.description': "Tilf\xf8j en brugerdefineret statusetiket",
    'fabric.editor.statusEditorLabel': 'Statusredigeringsprogram',
    'fabric.editor.statusPickerOpenedAlert': "Pop\xa0op-vinduet til statusredigering er \xe5bnet. Tryk p\xe5 Tab-tasten for at g\xe5 til pop\xa0op-vinduet",
    'fabric.editor.statusPlaceholder': 'Angiv en status',
    'fabric.editor.story': 'Historie',
    'fabric.editor.strike': 'Gennemstreget',
    'fabric.editor.subTask': 'Underopgave',
    'fabric.editor.subscript': "S\xe6nket skrift",
    'fabric.editor.subscript.off.superscript.on': "S\xe6nket skrift fra, h\xe6vet skrift til",
    'fabric.editor.success': 'Succes',
    'fabric.editor.successPanel': 'Succespanel',
    'fabric.editor.successPanel.description': "Tilf\xf8j tip i et farvet panel",
    'fabric.editor.superscript': "H\xe6vet skrift",
    'fabric.editor.superscript.off.subscript.on': "H\xe6vet skrift fra, s\xe6nket skrift til",
    'fabric.editor.supportAltText': "Alternativ tekst er nyttig, n\xe5r folk bruger sk\xe6rml\xe6sere pga. synshandicap.",
    'fabric.editor.table': 'Tabel',
    'fabric.editor.table.description': "Inds\xe6t en tabel",
    'fabric.editor.tableAlignmentOptions': 'Justeringsindstillinger',
    'fabric.editor.tableFullWidthLabel': 'Fuld bredde',
    'fabric.editor.tableHeader.sorting.asc': 'Stigende sortering anvendt',
    'fabric.editor.tableHeader.sorting.default': "Sort\xe9r kolonnen",
    'fabric.editor.tableHeader.sorting.desc': 'Faldende sortering anvendt',
    'fabric.editor.tableHeader.sorting.invalid': 'Du kan ikke sortere en tabel med flettede celler',
    'fabric.editor.tableHeader.sorting.no': "Ingen sortering anvendt p\xe5 kolonnen",
    'fabric.editor.tableOptions': 'Egenskaber for tabel',
    'fabric.editor.tableResizeDecreaseScreenReaderInformation': '{newWidth, plural, one {Tabelbredde reduceret til {newWidth,number} pixel.} other {Tabelbredde reduceret til {newWidth,number} pixel.}}',
    'fabric.editor.tableResizeIncreaseScreenReaderInformation': "{newWidth, plural, one {Tabelbredde \xf8get til {newWidth,number} pixel.} other {Tabelbredde \xf8get til {newWidth,number} pixels.}}",
    'fabric.editor.tableSelector': "Tabelst\xf8rrelse",
    'fabric.editor.tableSelector.description': "Tilf\xf8j en tabel ved hj\xe6lp af popup for at v\xe6lge en brugerdefineret st\xf8rrelse",
    'fabric.editor.tableSizeSelectorButton': '{numberOfColumns} af {numberOfRows}',
    'fabric.editor.tableSizeSelectorPopup': "V\xe6lger til tabelst\xf8rrelse",
    'fabric.editor.tables.adjustColumn': 'Tilpas kolonne',
    'fabric.editor.tables.columnResizeLast': "Du kan kun \xe6ndre st\xf8rrelsen p\xe5 denne kolonne til venstre.",
    'fabric.editor.tables.columnResizeOverflow': "Du kan kun \xe6ndre st\xf8rrelsen p\xe5 denne kolonne, mens tabellen har en rullebj\xe6lke.",
    'fabric.editor.tables.columnWidth': "{width, plural, one {Kolonnebredden blev \xe6ndret til {width} pixel} other {Kolonnebredden blev \xe6ndret til {width} pixels}}",
    'fabric.editor.tables.confirmDeleteLinkedModalMessage': 'Hvis du sletter {nodeName}, brydes forbindelsen til alt, der er forbundet til den.',
    'fabric.editor.tables.confirmDeleteLinkedModalOKButton': 'Slet',
    'fabric.editor.tables.resizeStop': "Stoppede med at \xe6ndre st\xf8rrelse",
    'fabric.editor.tables.resizeTable': "Tilpas st\xf8rrelsen p\xe5 tabellen",
    'fabric.editor.tables.startedColumnResize': "Startede med at \xe6ndre st\xf8rrelsen p\xe5 kolonne",
    'fabric.editor.task': 'Opgave',
    'fabric.editor.taskPlaceholder': 'Indtast din handling, og brug "@" for at tildele til nogen.',
    'fabric.editor.text.formatting.off': 'Tekstformatering fra',
    'fabric.editor.textColor': '{selectedColorName} tekstfarve',
    'fabric.editor.textColorTooltip': 'Tekstfarve',
    'fabric.editor.textFormat': "Format\xe9r tekst",
    'fabric.editor.textFormatting': 'Tekstformatering',
    'fabric.editor.textStyles': '{blockTypeName} tekstformatering',
    'fabric.editor.textStylesTooltip': 'Tekstformatering',
    'fabric.editor.threeColumns': 'Layout med tre kolonner',
    'fabric.editor.threeColumnsWithLeftSidebars': "Layout med tre kolonner med venstre sidebj\xe6lke",
    'fabric.editor.threeColumnsWithRightSidebars': "Layout med tre kolonner med h\xf8jre sidebj\xe6lke",
    'fabric.editor.threeColumnsWithSidebars': "Layout med tre kolonner med sidebj\xe6lker",
    'fabric.editor.time.ago': 'siden',
    'fabric.editor.time.updated': 'Opdateret',
    'fabric.editor.time.viewed': 'Vist',
    'fabric.editor.toolbarAppears': "V\xe6rkt\xf8jslinjen vises",
    'fabric.editor.toolbarLabel': 'Editor',
    'fabric.editor.toolbarMediaTitle': "Tilf\xf8j billede, video eller fil",
    'fabric.editor.toolbarPositionFixedAtTop': "Fastgjort \xf8verst",
    'fabric.editor.toolbarPositionInline': "P\xe5 linje med tekst",
    'fabric.editor.tooltip.blockPanel': 'et panel',
    'fabric.editor.tooltip.bulletList': 'en liste',
    'fabric.editor.tooltip.decisionList': 'en beslutningsliste',
    'fabric.editor.tooltip.defaultBlockNode': 'en bloknode',
    'fabric.editor.tooltip.nestedExpand': 'en indlejret udvidelse',
    'fabric.editor.tooltip.taskList': 'et handlingselement',
    'fabric.editor.turnInto': 'Skift til',
    'fabric.editor.twoColumns': 'Layout med to kolonner',
    'fabric.editor.typeAhead.popupLabel': "Resultater for automatisk fuldf\xf8relse",
    'fabric.editor.typeAhead.quickInsertInputLabel': "Begynd at skrive for at s\xf8ge efter eller filtrere genvejsmuligheder",
    'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel': "S\xf8g",
    'fabric.editor.typeAhead.quickInsertPopupLabel': "Genveje til inds\xe6ttelser og formatering",
    'fabric.editor.typeahead.emojiInputLabel': "Begynd at skrive for at s\xf8ge efter eller filtrere emojimuligheder",
    'fabric.editor.typeahead.emojiListItemLabel': 'Tekstgenvej {shortcut} til emojien {name}',
    'fabric.editor.typeahead.emojiPopupLabel': 'Emojigenveje',
    'fabric.editor.typeahead.mentionInputLabel': "Begynd at indtaste for at s\xf8ge efter brugere, du vil tagge",
    'fabric.editor.typeahead.mentionPopupLabel': 'Brugere, du kan tagge',
    'fabric.editor.typeahead.metionListItemLabel': 'Brugeren {name} @{shortName}',
    'fabric.editor.unableToLoadContent': "Vi kunne ikke indl\xe6se dette indhold",
    'fabric.editor.unableToOpenLink': "Kan ikke \xe5bne dette link",
    'fabric.editor.underline': 'Understreget',
    'fabric.editor.undo': 'Fortryd',
    'fabric.editor.unknown.label': 'Ukendt',
    'fabric.editor.unlink': 'Fjern link',
    'fabric.editor.unorderedList': 'Punktopstilling',
    'fabric.editor.unorderedList.description': 'Opret en ikke-sorteret liste',
    'fabric.editor.unsupportedBlockContent': "Denne editor underst\xf8tter ikke visning af dette indhold",
    'fabric.editor.unsupportedContentTooltip': "Indholdet er ikke tilg\xe6ngeligt i denne editor. Det bevares, n\xe5r du redigerer og gemmer",
    'fabric.editor.unsupportedInlineContent': "Ikke-underst\xf8ttet indhold",
    'fabric.editor.upDown': "N\xe5r du bruger piletasterne op og ned i f\xf8lgende indtastningsfelt opdateres datoen nedenfor",
    'fabric.editor.url': 'Visnings-URL',
    'fabric.editor.urlDescription': 'Vis link som URL-adresse',
    'fabric.editor.urlTitle': 'URL-adresse',
    'fabric.editor.useMarkdown': 'Brug markdown',
    'fabric.editor.viewAndAddCommentsOnMedia': "Se og tilf\xf8j kommentarer",
    'fabric.editor.viewCommentOnMedia': 'Se kommentarer',
    'fabric.editor.viewMore': 'Vis mere',
    'fabric.editor.viewMoreAriaLabel': 'Vis alle elementer',
    'fabric.editor.visit': "\xc5bn link i et nyt vindue",
    'fabric.editor.warning': 'Advarsel',
    'fabric.editor.warningPanel': 'Advarselspanel',
    'fabric.editor.warningPanel.description': "Tilf\xf8j en advarselsnote i et farvet panel",
    'fabric.editor.wrapLeft': 'Skub til venstre',
    'fabric.editor.wrapRight': "Skub til h\xf8jre",
    'fabric.emoji.label': 'Emoji',
    'fabric.theme.blue': "Bl\xe5",
    'fabric.theme.bold-blue': "St\xe6rk bl\xe5",
    'fabric.theme.bold-gray': "St\xe6rk gr\xe5",
    'fabric.theme.bold-green': "St\xe6rk gr\xf8n",
    'fabric.theme.bold-magenta': "St\xe6rk magenta",
    'fabric.theme.bold-orange': "St\xe6rk orange",
    'fabric.theme.bold-purple': "St\xe6rk lilla",
    'fabric.theme.bold-red': "St\xe6rk r\xf8d",
    'fabric.theme.bold-teal': "St\xe6rk turkis",
    'fabric.theme.bold-yellow': "St\xe6rk gul",
    'fabric.theme.bolder-blue': "St\xe6rkere bl\xe5",
    'fabric.theme.bolder-gray': "St\xe6rkere gr\xe5",
    'fabric.theme.bolder-green': "St\xe6rkere gr\xf8n",
    'fabric.theme.bolder-magenta': "St\xe6rkere magenta",
    'fabric.theme.bolder-orange': "St\xe6rkere orange",
    'fabric.theme.bolder-purple': "St\xe6rkere lilla",
    'fabric.theme.bolder-red': "St\xe6rkere r\xf8d",
    'fabric.theme.bolder-teal': "St\xe6rkere turkis",
    'fabric.theme.bolder-yellow': "St\xe6rkere gul",
    'fabric.theme.dark-blue': "M\xf8rk bl\xe5",
    'fabric.theme.dark-gray': "M\xf8rk gr\xe5",
    'fabric.theme.dark-green': "M\xf8rk gr\xf8n",
    'fabric.theme.dark-purple': "M\xf8rk lilla",
    'fabric.theme.dark-red': "M\xf8rk r\xf8d",
    'fabric.theme.dark-teal': "M\xf8rk teal",
    'fabric.theme.dark-yellow': "M\xf8rk gul",
    'fabric.theme.default': 'Standard',
    'fabric.theme.gray': "Gr\xe5",
    'fabric.theme.green': "Gr\xf8n",
    'fabric.theme.light-blue': "Lys bl\xe5",
    'fabric.theme.light-gray': "Lys gr\xe5",
    'fabric.theme.light-green': "Lys gr\xf8n",
    'fabric.theme.light-purple': 'Lys lilla',
    'fabric.theme.light-red': "Lys r\xf8d",
    'fabric.theme.light-teal': 'Lys teal',
    'fabric.theme.light-yellow': 'Lys gul',
    'fabric.theme.lime': "Limegr\xf8n",
    'fabric.theme.magenta': 'Magenta',
    'fabric.theme.no-color': "Ingen fremh\xe6vning",
    'fabric.theme.orange': 'Orange',
    'fabric.theme.purple': 'lilla',
    'fabric.theme.red': "R\xf8d",
    'fabric.theme.subtle-blue': "Svag bl\xe5",
    'fabric.theme.subtle-gray': "Svag gr\xe5",
    'fabric.theme.subtle-green': "Svag gr\xf8n",
    'fabric.theme.subtle-magenta': 'Svag magenta',
    'fabric.theme.subtle-orange': 'Svag orange',
    'fabric.theme.subtle-purple': 'Svag lilla',
    'fabric.theme.subtle-red': "Svag r\xf8d",
    'fabric.theme.subtle-teal': 'Svag turkis',
    'fabric.theme.subtle-yellow': 'Svag gul',
    'fabric.theme.teal': 'Teal',
    'fabric.theme.white': 'Hvid',
    'fabric.theme.yellow': 'Gul',
    'fabrid.editor.rowNumbers': "R\xe6kkenumre",
    'rovo.agents.dropdown.title': 'Agenter',
    'rovo.agents.dropdown.viewAgents.label': 'Vis alle agenter'
};

});


//# sourceMappingURL=da.73c64031.js.map
